
import Skeleton from '@/components/ui/skeleton.vue';

export default {
  name: 'LoadMore',

  components: {
    Skeleton,
  },

  props: {
    next: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      observer: null,
    };
  },

  computed: {
    hasMore() {
      return this.total && this.next - 1 < this.total;
    },

    canLoadMore() {
      return this.hasMore && this.loading === false;
    },
  },

  mounted() {
    this.observer = new IntersectionObserver(this.onIntersect, {
      root: null,
      rootMargin: '300px',
      threshold: 0,
    });

    this.observer.observe(this.$el);
  },

  beforeDestroy() {
    this.observer.unobserve(this.$el);
  },

  methods: {
    onIntersect(entries) {
      if (this.canLoadMore === true && entries[0].isIntersecting) {
        this.$emit('more');
      }
    },
  },
};
